import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { useGetAccessWindowsByShift } from "@src/appV2/redesign/DailyView/ShiftDetails/api/useGetAccessWindowsByShift";

const ONSITE_REPLACEMENT_WORKER_WINDOW_NAME = "ONSITE_REPLACEMENT_WORKER";

interface UseIsOnsiteRwWindowActiveParams {
  shiftId: string;
  enabled?: boolean;
}

export function useIsOnsiteRwWindowActive(params: UseIsOnsiteRwWindowActiveParams): boolean {
  const { shiftId, enabled = true } = params;

  const ffConfig = useCbhFlag(CbhFeatureFlag.ONSITE_REPLACEMENT_WORKER_URGENCY, {
    defaultValue: {
      enabled: false,
      dryRun: true,
      delayMinutes: 10,
      maxShiftGapMinutes: 30,
      leadTimeRange: { min: 0, max: 8 },
      allowedShiftSlots: [],
    },
  });
  const isFeatureEnabled = ffConfig.enabled && !ffConfig.dryRun;

  const { data: accessWindowsData } = useGetAccessWindowsByShift(
    { shiftId },
    { enabled: enabled && isFeatureEnabled }
  );

  return (
    enabled &&
    isFeatureEnabled &&
    (accessWindowsData?.data.some(
      (w) => w.attributes.windowName === ONSITE_REPLACEMENT_WORKER_WINDOW_NAME
    ) ??
      false)
  );
}
